export default __webpack_public_path__ + "static/media/swimIllustration.6c7683bc.png";